.scroll {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11.5px;
}

/* `--bg2` (not `--surf2`) so the header reads as a recess against the card. */
.table th {
  padding: 9px var(--sp-5);
  border-bottom: 1px solid var(--line);
  background: var(--bg2);
  color: var(--sage);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap;
}

.table td {
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--line);
  color: var(--text2);
  vertical-align: middle;
}

.table td b,
.table td strong {
  color: var(--text);
  font-weight: 700;
}

.table tbody tr:hover td {
  background: var(--surf2);
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.clickable {
  cursor: pointer;
}

.numeric {
  text-align: right;
  font-family: var(--font-mono);
}

.mono {
  font-family: var(--font-mono);
  font-size: 10.5px;
}

.actions {
  display: flex;
  gap: var(--sp-2);
  align-items: center;
}

.emptyCell {
  padding: 36px var(--sp-7);
  text-align: center;
  color: var(--sage);
  font-size: 12px;
}
.emptyCell:hover {
  background: none;
}
